/**
 * Extract task IDs from API response
 * @param response - Response from classify files API
 * @returns Array of task IDs
 */
export const extractTaskIds = (response: {
  jobs?: Array<{ task_id?: string }>;
}): string[] => {
  if (!response || !response.jobs || !Array.isArray(response.jobs)) {
    console.warn("Received invalid response format:", response);
    return [];
  }

  return response.jobs
    .filter((job) => job && typeof job.task_id === "string")
    .map((job) => job.task_id as string);
};
